import ApiClient from "@/services/ApiClient";

export function fetchApplications(query) {
    return ApiClient.get('/applications/list', {params: query});
}

export function fetchApplicationTypes(){
    return ApiClient.get('/applications/types');
}